import React from 'react'
import { connect } from 'react-redux'
import { getSelfUser } from '@sportninja/common/selectors/users'
import ProfilePage from './ProfilePage'
import { ProfileProvider } from './context/ProfileContext'
import { ProfileIdentifier, ProfileUser } from './types'

interface ProfileEntryStateProps {
  selfUser?: ProfileUser | null
}

/**
 * Entry point for the modernized profile page.
 */
const ProfileEntry: React.FC<ProfileEntryStateProps> = ({ selfUser }) => {
  return (
    <ProfileProvider selfUserId={selfUser?.id as ProfileIdentifier | undefined}>
      <ProfilePage />
    </ProfileProvider>
  )
}

const mapStateToProps = (state: any): ProfileEntryStateProps => ({
  selfUser: getSelfUser(state) as ProfileUser | null,
})

export default connect(mapStateToProps)(ProfileEntry)
